import createReducer from '../../reducers/utils/createReducer';
import * as c from './types';

const initialState = {
  data: {},
  isLoading: false,
  error: null,
  isCreationInProgress: false,
  isDeletionInProgress: [],
  isUpdateInProgress: false
};

export default createReducer(initialState, {
  [c.GET_ALERT_SETTINGS_REQUEST]: (state) => ({
    ...state,
    error: null,
    isLoading: true
  }),
  [c.GET_ALERT_SETTINGS_SUCCESS]: (state, { payload }) => ({
    ...state,
    data: payload,
    isLoading: false,
    isDeletionInProgress: new Array(payload.length).fill(false)
  }),
  [c.GET_ALERT_SETTINGS_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isLoading: false
  }),
  [c.CREATE_ALERT_SETTING_REQUEST]: (state) => {
    return {
      ...state,
      error: null,
      isCreationInProgress: true
    };
  },
  [c.CREATE_ALERT_SETTING_SUCCESS]: (state, { payload }) => {
    const newState = { ...state };
    const data = [...newState.data];
    data.push(payload);
    return {
      ...state,
      isCreationInProgress: false,
      data
    };
  },
  [c.CREATE_ALERT_SETTING_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isCreationInProgress: false
  }),
  [c.DELETE_ALERT_SETTING_REQUEST]: (state, { payload }) => {
    const newState = { ...state, error: null };
    newState.isDeletionInProgress[payload.index] = true;
    return newState;
  },
  [c.DELETE_ALERT_SETTING_SUCCESS]: (state, { payload }) => {
    const data = [...state.data];
    return {
      ...state,
      error: null,
      data: data.filter((e) => e.id !== payload.id),
      isDeletionInProgress: new Array(state.data.length - 1).fill(false)
    };
  },
  [c.DELETE_ALERT_SETTING_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isDeletionInProgress: new Array(state.data.length).fill(false)
  }),
  [c.UPDATE_ALERT_SETTING_REQUEST]: (state) => ({
    ...state,
    error: null,
    isUpdateInProgress: true
  }),
  [c.UPDATE_ALERT_SETTING_SUCCESS]: (state) => ({
    ...state,
    isUpdateInProgress: false
  }),
  [c.UPDATE_ALERT_SETTING_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isUpdateInProgress: false
  })
});
